<script lang="ts">
    import {DateUtil} from "../../../lib/Common/Value/DateUtil";

    export let model;
    export let isHorizontal = false;
    export let isShowUser = true;


</script>

<div class="created-updated-view" class:horizontal={isHorizontal}>
    <div class="created">
        <span>作成: </span>
        <span class="date">
            { DateUtil.createSimpleDateTimeFormatTextForString(model.created_at)  }
        </span>
        {#if isShowUser}
            {#if model.created_by != null}
            <span class="user">
                {#if model.created_by_name != null}
                    ( by { model.created_by_name } )
                {:else}
                    ( by user id:{ model.created_by } )
                {/if}
            </span>
            {/if}
        {/if}
    </div>

    <div class="updated">
        <span>更新: </span>
        <span class="date">
            { DateUtil.createSimpleDateTimeFormatTextForString(model.updated_at)  }
        </span>
        {#if isShowUser}
            {#if model.updated_by != null}
                <span class="user">
                    {#if model.updated_by_name != null}
                        ( by { model.updated_by_name } )
                    {:else}
                        ( by user id:{ model.updated_by } )
                    {/if}
                </span>
            {/if}
        {/if}
    </div>


</div>
<style lang="scss">
    .created-updated-view {
        display: flex;
        flex-direction: column;
        gap: 0.5em;

        .user {
            opacity: 0.8;
        }

        &.horizontal {
            flex-direction: row;

        }
    }
</style>